import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import DashboardEditVariablesModal from 'modules/reports/components/DashboardEditVariablesModal'
// TODO: consider promoting this to the reports root component folder
import FormComponent, {
  VariableForm,
} from 'modules/reports/components/DashboardShow/components/Content/DashboardFilters/VariableForm'
import { VariableValueForm } from 'modules/reports/components/DashboardShow/components/Content/DashboardFilters/variableValueForm'
import type Dashboard from 'modules/reports/store/models/Dashboard'

type PopoverContentProps = React.ComponentProps<typeof PopoverContent>

const OptionsButton = ({ dashboard, form }: { dashboard: Dashboard; form: VariableValueForm }) => {
  const [showEditModal, setShowEditModal] = React.useState(false)
  const [open, toggle] = useToggle(false)

  const editForm = React.useRef(
    new VariableForm({
      name: form.get('name').value,
      type: form.get('type').value,
      default_value: form.get('default_value').value,
    })
  ).current

  const { running: isProcessing, performAction: updateOnSubmit } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      const data = dashboard.variables.map((variable) => {
        if (variable.name === editForm.get('name').value) {
          return editForm.data()
        }

        return variable
      })
      await dashboard.save(
        {
          variables: data,
        },
        {}
      )
      closePortal()
    },
    {
      successFlash: true,
      errorFlash: false,
    }
  )

  const { performAction: deleteOnSubmit } = useAsyncAction((form: VariableValueForm) => {
    const data = dashboard.variables.filter((variable) => variable.name !== form.get('name').value)

    return dashboard.save(
      {
        variables: data,
      },
      {}
    )
  })

  const options: PopoverContentProps['options'] = [
    {
      onClick: () => setShowEditModal(true),
      title: i18n.t('custom_reports.edit_filter'),
    },
    {
      onClick: async () => await deleteOnSubmit(form),
      title: i18n.t('common.remove'),
      type: 'wrong',
    },
  ]

  return (
    <>
      {showEditModal && (
        <DashboardEditVariablesModal
          onClose={() => setShowEditModal(false)}
          onSubmit={updateOnSubmit}
          submitDisabled={isProcessing}
        >
          <FormComponent form={editForm} readOnly variables={[]} />
        </DashboardEditVariablesModal>
      )}
      <Popover attachment="top right" targetAttachment="bottom center" toggle={toggle} open={open}>
        <Button onClick={toggle(true)} type="secondary" iconName="ellipsis" />
        <PopoverContent onClose={toggle(false)} options={options} />
      </Popover>
    </>
  )
}

export default observer(OptionsButton)
